import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/logo.png';
const _withScopeId = n => (_pushScopeId("data-v-251551d4"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "caodi"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "logo animate__animated animate__flipInX animate__delay-1s"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_3 = {
  class: "animate__animated animate__zoomIn animate__delay-2s login_form"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  style: {
    "margin": "16px"
  }
};
const _hoisted_6 = {
  class: "content"
};
const _hoisted_7 = {
  class: "card"
};
const _hoisted_8 = {
  class: "card-body"
};
const _hoisted_9 = {
  class: "card-title"
};
const _hoisted_10 = {
  class: "card-text"
};
const _hoisted_11 = {
  key: 0,
  style: {
    "width": "100vw",
    "height": "100vh",
    "background-color": "rgba(0, 0, 0, 0.7)",
    "position": "fixed",
    "top": "0",
    "left": "0",
    "z-index": "99999"
  }
};
const _hoisted_12 = {
  style: {
    "width": "81vw",
    "height": "81vh",
    "background-color": "#fff",
    "position": "absolute",
    "box-sizing": "border-box",
    "top": "10vh",
    "left": "9.5vw"
  }
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  style: {
    "width": "81vw",
    "height": "81vw",
    "position": "absolute",
    "top": "0",
    "left": "0"
  },
  class: "yzm_div"
};
const _hoisted_15 = ["id", "onClick"];
const _hoisted_16 = {
  style: {
    "width": "81vw",
    "height": "21vw",
    "position": "absolute",
    "top": "82vw",
    "left": "0"
  }
};
const _hoisted_17 = {
  style: {
    "font-size": "0.3rem",
    "color": "#333",
    "text-align": "center",
    "line-height": "0.4rem",
    "margin-bottom": "0.2rem"
  }
};
const _hoisted_18 = {
  style: {
    "width": "60%",
    "margin": "0 auto"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item");
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu");
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");
  const _component_van_field = _resolveComponent("van-field");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_form = _resolveComponent("van-form");
  const _component_Footer = _resolveComponent("Footer");
  const _component_van_back_top = _resolveComponent("van-back-top");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  return _openBlock(), _createElementBlock("div", null, [_withDirectives(_createVNode(_component_van_nav_bar, {
    title: $data.lang.u1,
    onClickLeft: $options.onClickLeft
  }, {
    left: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "phone-circle-o",
      size: "24",
      color: "#061c3c"
    })]),
    right: _withCtx(() => [_createVNode(_component_van_dropdown_menu, {
      style: {
        "max-width": "1.5rem"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_van_dropdown_item, {
        modelValue: $data.select_lang.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.select_lang.value = $event),
        options: $data.lang_list,
        onChange: $options.select
      }, null, 8, ["modelValue", "options", "onChange"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["title", "onClickLeft"]), [[_vShow, $data.load == false]]), _withDirectives(_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createVNode(_component_van_form, {
    onSubmit: $options.reg
  }, {
    default: _withCtx(() => [_createVNode(_component_van_cell_group, {
      inset: ""
    }, {
      default: _withCtx(() => [_createVNode(_component_van_tabs, {
        active: $data.active,
        "onUpdate:active": _cache[7] || (_cache[7] = $event => $data.active = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tab, {
          title: $data.lang.t3
        }, {
          default: _withCtx(() => [_createVNode(_component_van_field, {
            modelValue: $data.r_user_name,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.r_user_name = $event),
            name: $data.lang.t4,
            label: $data.lang.t4,
            "label-align": "top",
            placeholder: $data.lang.tu3,
            rules: [{
              required: true,
              message: $data.lang.tu3
            }]
          }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
            modelValue: $data.yzm_code,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.yzm_code = $event),
            "label-align": "top",
            center: "",
            clearable: "",
            label: $data.lang.t17,
            placeholder: $data.lang.t17
          }, {
            button: _withCtx(() => [_createElementVNode("img", {
              src: $data.yzm_img,
              onClick: _cache[2] || (_cache[2] = $event => $options.get_img()),
              style: {
                "height": "0.6rem"
              }
            }, null, 8, _hoisted_4)]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"]), _createVNode(_component_van_field, {
            modelValue: $data.sms,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.sms = $event),
            "label-align": "top",
            center: "",
            clearable: "",
            label: $data.lang.t13,
            placeholder: $data.lang.t13
          }, {
            button: _withCtx(() => [_createVNode(_component_van_button, {
              size: "small",
              type: "primary",
              onClick: $options.send
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t14), 1)]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          }, 8, ["modelValue", "label", "placeholder"]), _createVNode(_component_van_field, {
            modelValue: $data.r_pass,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.r_pass = $event),
            type: "password",
            name: $data.lang.t5,
            label: $data.lang.t5,
            "label-align": "top",
            placeholder: $data.lang.tu4,
            rules: [{
              required: true,
              message: $data.lang.tu4
            }]
          }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createVNode(_component_van_field, {
            modelValue: $data.r_zfpass,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.r_zfpass = $event),
            type: "password",
            name: $data.lang.t6,
            label: $data.lang.t6,
            "label-align": "top",
            placeholder: $data.lang.t6,
            rules: [{
              required: true,
              message: $data.lang.t6
            }]
          }, null, 8, ["modelValue", "name", "label", "placeholder", "rules"]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit",
            color: "#061c3c"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.tu1), 1)]),
            _: 1
          }), _createVNode(_component_van_button, {
            round: "",
            block: "",
            type: "primary",
            color: "#061c3c",
            style: {
              "margin-top": "0.3rem"
            },
            onClick: $options.login
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.t8), 1)]),
            _: 1
          }, 8, ["onClick"])])]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["active"])]),
      _: 1
    })]),
    _: 1
  }, 8, ["onSubmit"])])], 512), [[_vShow, $data.load == false]]), _createVNode(_component_Footer, {
    lang_list: $data.lang_list,
    lang: $data.lang
  }, null, 8, ["lang_list", "lang"]), _createVNode(_component_van_back_top, {
    bottom: "10vh",
    style: {
      "background-color": "#061c3c"
    }
  }), _createVNode(_component_van_action_sheet, {
    show: $data.show,
    "onUpdate:show": _cache[9] || (_cache[9] = $event => $data.show = $event),
    title: $data.lang.tu8
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("h5", _hoisted_9, _toDisplayString($data.lang.tu6), 1), _createElementVNode("p", _hoisted_10, _toDisplayString($data.zhu), 1), _createElementVNode("a", {
      class: "btn btn-primary",
      onClick: _cache[8] || (_cache[8] = (...args) => $options.copyText && $options.copyText(...args))
    }, _toDisplayString($data.lang.tu7), 1)])])])]),
    _: 1
  }, 8, ["show", "title"]), $data.yzm_tp ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("img", {
    src: $data.yzm_tp,
    style: {
      "width": "100%",
      "position": "absolute",
      "top": "0",
      "left": "0"
    }
  }, null, 8, _hoisted_13), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.yzm_arr, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      id: index,
      onClick: $event => $options.che_y(index),
      key: index,
      class: _normalizeClass(item.che == 1 ? 'che' : '')
    }, null, 10, _hoisted_15);
  }), 128))]), _createElementVNode("div", _hoisted_16, [_createElementVNode("h3", _hoisted_17, _toDisplayString($data.lang.tu18) + "：" + _toDisplayString($data.yzm.name), 1), _createElementVNode("h3", {
    style: {
      "font-size": "0.28rem",
      "color": "red",
      "text-align": "center",
      "line-height": "0.4rem"
    },
    onClick: _cache[10] || (_cache[10] = (...args) => $options.send && $options.send(...args))
  }, _toDisplayString($data.lang.tu19), 1), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
    round: "",
    block: "",
    type: "primary",
    color: "#061c3c",
    style: {
      "margin-top": "0.3rem"
    },
    onClick: $options.yes_send
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.lang.tu20), 1)]),
    _: 1
  }, 8, ["onClick"])])])])])) : _createCommentVNode("", true)]);
}